import axioslib, { AxiosInstance, AxiosRequestConfig } from "axios";
import { Logger } from "@iloq/shared";
import config from "@/config";

export default class AuthApi {
  private axios: AxiosInstance;

  private axiosForExtranet: AxiosInstance;

  constructor() {
    this.axios = axioslib.create();
    this.axiosForExtranet = axioslib.create({ withCredentials: true });
  }

  fetchAuthToken(refreshToken: string): Promise<string> {
    Logger.debug("AuthApi.fetchAuthToken, refresh token:", refreshToken);
    const options: AxiosRequestConfig = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
      url: "/user/login/jwt/fetch-auth-token",
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("AuthApi.fetchAuthToken failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("AuthApi.fetchAuthToken result:", result);
        return result.data.authToken;
      });
  }

  fetchDownloadToken(refreshToken: string): Promise<string> {
    Logger.debug("AuthApi.fetchDownloadToken, refresh token:", refreshToken);
    const options: AxiosRequestConfig = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
      url: "/user/login/jwt/fetch-download-token",
    };
    return this.axios(options)
      .catch((error) => {
        Logger.error("AuthApi.fetchDownloadToken failed:", error);
        return Promise.reject(error);
      })
      .then((result) => {
        Logger.debug("AuthApi.fetchDownloadToken result:", result);
        return result.data.downloadToken;
      });
  }

  logout(refreshToken: string): Promise<any> {
    Logger.debug("AuthApi.logout");
    const options: AxiosRequestConfig = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
      url: "/user/login/jwt/logout",
    };
    return this.axios(options)
      .catch((error) => Logger.warn("Logout failed:", error))
      .then(() => Logger.debug("Logout succesful"));
  }

  extranetLogin(azureAdToken: string): Promise<any> {
    if (config.get("extranetUrlForLogin")) {
      Logger.debug("AuthApi.extranetLogin");
      const options: AxiosRequestConfig = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${azureAdToken}`,
        },
        url: config.get("extranetUrlForLogin"),
      };
      return this.axiosForExtranet(options)
        .catch((error) => Logger.warn("Extranet login failed:", error))
        .then(() => Logger.debug("Extranet login succesful"));
    }

    Logger.debug("AuthApi.extranetLogin is disabled");
    return Promise.resolve();
  }
}

export interface IRefreshTokenReply {
  refreshToken: string;
  authToken: string;
}
